import spanishMessages from '@blackbox-vision/ra-language-spanish';

export const es = {
  ...spanishMessages,
  "Missing Refresh Token (audience: '', scope: 'openid profile email offline_access')":
    'Por favor inicie sesión para ingresar!',
  app: {
    title: 'Atelier Antropometría',
    subtitle: 'Laboratorio de Biometría & Somatotipo',
    modules: 'Módulos',
    configure_modules: 'Configuración de Módulos',
    configure_modules_tooltip: 'Configurar Módulos y Funcionalidades',
    language: 'Idioma',
    espanol: 'Español',
    english: 'Inglés',
  },
  auth: {
    welcome_title: 'Acceso al Laboratorio Antropométrico',
    welcome_subtitle: 'Sistema Oficial de Biometría & Somatotipificación',
    login_prompt: 'Ingrese sus credenciales profesionales autorizadas para acceder a los expedientes.',
    email_or_username: 'Correo Electrónico o Usuario',
    password: 'Password / Contraseña',
    login_button: 'Entrar al Atelier',
    authenticating: 'Autenticando...',
    invalid_credentials: 'Las credenciales ingresadas son inválidas o no están registradas.',
    role_super_admin: 'Super Administrador',
    role_nutritionist: 'Especialista Nutricionista',
    logged_in_as: 'En sesión',
    logout: 'Cerrar Sesión',
    restricted_title: 'Acceso Restringido',
    restricted_message: 'Este expediente confidencial pertenece a otro especialista. No tiene permisos para consultar o modificar esta información.',
    return_to_list: 'Volver a Mis Pacientes',
    create_specialist: 'Registrar Nuevo Especialista',
    specialist_assigned: 'Asignado a su consulta profesional',
    filter_by_nutritionist: 'Filtrar por Especialista',
    all_specialists: 'Todos los Especialistas',
  },
  features: {
    title: 'Configuración de Módulos & Funcionalidades',
    description:
      'Habilite o deshabilite módulos para personalizar la interfaz del laboratorio según su flujo de trabajo. Los cambios se aplican instantáneamente en el menú y las vistas.',
    presets_title: 'PRESETS RÁPIDOS',
    preset_all: 'Todos los Módulos (Completo)',
    preset_clinical: 'Clínico Básico (Pacientes y Evaluaciones)',
    preset_somatotype_only: 'Solo Somatocarta y Referencias',
    preset_minimal: 'Mínimo (Solo Pacientes)',
    module_status: 'ESTADO DEL MÓDULO',
    active: 'ACTIVO',
    inactive: 'INACTIVO',
    reset: 'Restablecer Valores',
    apply: 'Aceptar',
    user_title: 'Expediente de Pacientes',
    user_desc:
      'Gestión integral del historial clínico, datos demográficos y antecedentes de atletas y pacientes.',
    measurement_title: 'Evaluaciones Antropométricas',
    measurement_desc:
      'Registro de medidas estandarizadas ISAK: pliegues cutáneos, perímetros corporales y diámetros óseos.',
    nutritionist_title: 'Directorio de Nutricionistas',
    nutritionist_desc:
      'Catálogo de especialistas y profesionales del laboratorio encargados de las evaluaciones.',
    referenced_somatotype_title: 'Somatotipos de Referencia',
    referenced_somatotype_desc:
      'Catálogo de perfiles morfológicos de referencia de élite por deporte y género.',
    results_analytics_title: 'Analítica & Somatocarta',
    results_analytics_desc:
      'Cálculo de somatotipo de Heath-Carter, dispersión cartesiana, IMC y porcentajes grasos.',
    pdf_export_title: 'Exportación de Reportes PDF',
    pdf_export_desc:
      'Generación y descarga de fichas antropométricas en formato documental imprimible.',
  },
  measurement_show: {
    title: 'Ficha de Evaluación Antropométrica',
    protocol: 'PROTOCOLO ISAK — CONTROL #%{control}',
    download_pdf: 'Descargar Ficha PDF',
    generating_pdf: 'Generando...',
    view_analytics: 'Ver Somatocarta & Gráficos',
    athlete: 'Atleta',
    registered_athlete: 'Atleta registrado',
    nutritionist: 'Nutricionista',
    section_a: 'Sección A: Datos Básicos & Evaluación',
    control_number: 'Número de Control',
    height: 'Talla',
    weight: 'Peso',
    wingspan: 'Envergadura',
    training_period: 'Período de Entrenamiento',
    notes: 'Notas de Evaluación',
    section_b: 'Sección B: Pliegues Cutáneos (mm)',
    triceps: 'Tríceps',
    subscapular: 'Subescapular',
    biceps: 'Bíceps',
    iliac_crest: 'Cresta Ilíaca',
    supraspinale: 'Supraespinal',
    abdominal: 'Abdominal',
    front_thigh: 'Muslo Anterior',
    medial_calf: 'Pantorrilla Medial',
    section_c: 'Sección C: Perímetros Corporales (cm)',
    arm_relaxed: 'Brazo Relajado',
    arm_flexed: 'Brazo Flexionado',
    forearm: 'Antebrazo',
    wrist: 'Muñeca',
    chest: 'Tórax',
    waist: 'Cintura',
    hip: 'Cadera',
    thigh: 'Muslo Superior',
    thigh_max: 'Muslo Máximo',
    thigh_mid: 'Muslo Medio',
    calf: 'Pantorrilla',
    ankle: 'Tobillo',
    section_d: 'Sección D: Diámetros Óseos & Somatotipo (cm)',
    biacromial: 'Biacromial',
    transverse_chest: 'Tórax Transverso',
    anterior_posterior_chest: 'Tórax Anteroposterior',
    biiliocristal: 'Bi-iliocrestal',
    humerus: 'Humeral (Húmero)',
    femur: 'Femoral (Fémur)',
    ref_somatotype: 'Deporte de Referencia',
    xy_coords: 'Coordenadas Referencia (X, Y)',
    calculated_bmi: 'IMC Calculado',
    estimated_fat_mass: 'Masa Grasa Estimada',
    loading: 'Cargando ficha de medición...',
    error: 'Error al cargar la evaluación.',
  },
  user_show: {
    dossier_title: 'EXPEDIENTE DEL ATLETA / PACIENTE — ID #%{id}',
    personal_data: 'Datos Personales',
    contact_assignment: 'Contacto & Asignación',
    evaluation_history: 'Historial de Evaluaciones Antropométricas',
    body_comp_progression: 'Progresión de Composición Corporal',
    somatotype_chart: 'Gráfico de Somatotipo',
  },
  nutritionist_show: {
    specialist: 'ESPECIALISTA EN NUTRICIÓN & ANTROPOMETRÍA',
    dossier_title: 'Ficha de Registro Profesional',
    created_at: 'Fecha de Alta',
    updated_at: 'Última Actualización',
  },
  results: {
    title: 'Informe Biométrico & Diagnóstico Morfológico',
    control_caption: 'CONTROL #%{control} — EVALUACIÓN ANTROPOMÉTRICA',
    back_to_measurements: 'Volver a Mediciones',
    patient: 'Paciente',
    height: 'Talla',
    weight: 'Peso',
    bmi: 'IMC',
    loading: 'Cargando informe biométrico y morfológico...',
    tabulated_ledger: 'Cuaderno Oficial de Datos Tabulados',
    tabulated_subtitle: 'Cálculos de Composición Corporal, Índices Fisiológicos y Somatotipo Heath-Carter',
    table_indices: 'Tabla I: Índices Fisiológicos & Antropométricos',
    table_fat_models: 'Tabla II: Modelos de Grasa & Masas Corporales',
    table_somatotype: 'Tabla III: Parámetros del Somatotipo Heath-Carter',
    col_parameter: 'Variable / Parámetro',
    col_value: 'Valor Calculado',
    col_unit: 'Unidad',
    unit_adimensional: 'Adimensional',
  },
  somatotype: {
    reference_profile: 'PERFIL MORFOLÓGICO DE REFERENCIA — ID #%{id}',
    main_activity: 'ACTIVIDAD PRINCIPAL',
    chart_title: 'GRÁFICO DE SOMATOCARTA',
    current_profile: 'Perfil Actual',
    projected_ideal: 'Ideal Proyectado',
    target_min: 'MÍN: 1.0',
    target_max: 'MÁX: 10.0',
    target_goal: 'OBJETIVO: 5.5',
    to_goal: '+0.42 PARA META',
    lean_mass_opt: 'OPTIMIZACIÓN DE MASA MAGRA',
    morphological_analysis: 'Análisis Morfológico',
    dominant_profile: 'Perfil Dominante',
    sport_aptitude: 'Aptitud',
    recommendation: 'Recomendación',
    center_title: 'Centro de Alto Rendimiento',
    center_subtitle: 'Sede Central - Departamento de Biomecánica & Nutrición',
    certification: 'CERTIFICACIÓN VITALITY',
    edit: 'EDITAR',
    new_entry: 'NUEVA ENTRADA',
    edit_record: 'EDICIÓN DE REGISTRO',
    data_record: 'Registro de Datos',
    physiological_data: 'Datos Fisiológicos',
    enter_physiological: 'Ingrese los parámetros fisiológicos para el análisis del somatotipo.',
    components: 'COMPONENTES DEL SOMATOTIPO',
    cartesian_coords: 'COORDENADAS CARTESIANAS',
    live_preview: 'Previsualización del Gráfico Somatotipo',
    profile_analysis: 'Análisis de Perfil',
    muscle_balance: 'Balance Muscular',
    adiposity_level: 'Nivel de Adiposidad',
    high: 'Alto',
    moderate: 'Moderado',
    low: 'Bajo',
    save: 'GUARDAR',
    delete_measurement: 'ELIMINAR MEDICIÓN',
    sport: 'Deporte',
    gender: 'Género',
    male: 'MASCULINO',
    female: 'FEMENINO',
    act: 'Act.',
    subaquatic: 'Subacuática',
    dominant_prefix: 'Predominancia',
    dominant_suffix: 'La robustez muscular es el factor determinante, con una presencia moderada de tejido adiposo que facilita la flotabilidad neutra y resistencia física general.',
    aptitude_desc: 'Alta capacidad de reserva energética. Ideal para inmersiones prolongadas de baja intensidad. Estabilidad hidrodinámica excelente debido al centro de masa bajo.',
    rec_item_1: 'Focalizar en entrenamiento hipertrófico específico.',
    rec_item_2: 'Control glucémico estricto previo a sesión.',
    rec_item_3: 'Optimizar ratio potencia/peso (W/kg).',
    reference_morphogram: 'Morfograma Somatotípico de Referencia',
    cartesian_graphs: 'Coordenadas Cartesianas & Gráficos',
    key_values: 'Valores Clave del Somatotipo',
    preview: 'Vista Previa de la Somatocarta',
    classification: 'Clasificación Predominante',
    title: 'Cálculo del Somatotipo',
  },
  myroot: {
    download: 'Descargar',
    results: 'Ver Resultados',
    password: 'Contraseña',
    addressAndPhone: 'Dirección & Teléfono',
    identity: 'Identidad',
    male: 'Masculino',
    female: 'Femenino',
    mediciones: 'Mediciones',
    AddressPhone: 'Dirección y Teléfono',
    pliegues: 'Pliegues (mm)',
    perímetros: 'Perímetros (cm)',
    diametro: 'Diámetro (cm)',
    somatotipo: 'Somatotipo de Referencia',
    empty: 'No hay elementos creados',
    grams: 'Gramos',
    total_calories: 'Calorías Totales',
    simulate_results: 'Simular Resultados',
    welcomelogin: 'Bienvenido al portal del nutricionista',
    login: 'Autenticarse',
    bodyComposition: 'Composición corporal',
    fatPercentageIndices: 'Índices de % de grasa',
    welcomeScheduler: 'Citas para evaluaciones esta semana',
    ExpectedValues: 'Valores Esperados',
    'somatotipo de referencia': 'Somatotipo de Referencia',
    'somatotipo actual': 'Somatotipo Actual',
    endomorph: 'Endomorfo',
  },
  resources: {
    user: {
      name: 'Usuario |||| Usuarios',
      fields: {
        firstname: 'Nombre',
        lastname: 'Apellido',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        address: 'Dirección',
        birthday: 'Fecha De Nacimiento',
        gender: 'Género',
        created_at: 'Creado',
        updated_at: 'Actualizado',
        password: 'Contraseña',
        confirm_password: 'Confirmar Contraseña',
        plans: 'Planes de Alimentación',
        measurements: 'Mediciones',
        nutritionist: 'Nutricionista',
      },
    },
    measurement: {
      name: 'Medición |||| Mediciones',
      fields: {
        nutritionist_id: 'Nutricionista',
        evaluation_date: 'Fecha de Evaluación',
        dm_elbow: 'Diámetro Codo (cm)',
        dm_knee: 'Diámetro Rodilla (cm)',
        dm_wrist: 'Diámetro Muñeca (cm)',
        plg_triceps: 'Pliegue Tríceps (mm)',
        plg_bicep: 'Pliegue Bíceps (mm)',
        plg_subscapular: 'Pliegue Subescapular (mm)',
        plg_suprailiac: 'Pliegue Suprailiaco (mm)',
        plg_supraspinal: 'Pliegue Supraespinal (mm)',
        plg_abdominal: 'Pliegue Abdominal (mm)',
        plg_thigh: 'Pliegue Muslo (mm)',
        plg_calf: 'Pliegue Pantorrilla (mm)',
        plg_armpit: 'Pliegue Axila (mm)',
        plg_chest: 'Pliegue Pecho (mm)',
        prm_arm: 'Perímetro Brazo (cm)',
        prm_arm_contracted: 'Perímetro Brazo Contraído (cm)',
        prm_wrist: 'Perímetro Muñeca (cm)',
        prm_waist: 'Perímetro Cintura (cm)',
        prm_hip: 'Perímetro Cadera (cm)',
        prm_calf: 'Perímetro Pantorrilla (cm)',
        prm_chest: 'Perímetro Pecho (cm)',
        prm_thigh: 'Perímetro Muslo (cm)',
        x: 'x',
        y: 'y',
        fitness_level: 'Nivel de Entrenamiento',
        height: 'Altura (cm)',
        weight: 'Peso (kg)',
        creatinine: 'Creatinina',
        t3_t4: 'T3_T4',
        triglycerides: 'Triglicéridos',
        uric_acid: 'Ácido Úrico',
        user_id: 'Usuario',
        referenced_somatotype_id: 'Deporte',
        control: 'Control',
        notes: 'Notas',
        resultX: 'Resultado X',
        resultY: 'Resultado Y',
        endomorph: 'Endomorfo',
        mesomorph: 'Mesomorfo',
        ectomorph: 'Ectomorfo',
        imc: 'IMC',
        iaks: 'IAKS',
        conicIndex: 'Índice Cónico',
        sumOfPlgs: 'Suma de Pliegues',
        fatWeight: 'Peso de Grasa',
        freeFatWeight: 'Peso Libre de Grasa',
        desiredIMC: 'IMC Deseado',
        complexion: 'Compleción',
        desiredWeight: 'Peso Deseado',
        yhaszFatPercentage: '% de Grasa Yhasz',
        sumaPlieguesEndo: 'Suma de Pliegues Endo',
        desiredFat2MethodPercentage: '% Deseado del Método 2 de Grasa',
        yhaszFatPercentageSumaPliegues: '% de Grasa Yhasz Suma de Pliegues',
        fatPercentageForPerformance: '% Graso para Rendimiento',
        trainingPeriod: 'Período de Entrenamiento',
        modality: 'Modalidad',
        birthdayDate: 'Fecha de Nacimiento',
        gender: 'Género',
        age: 'Edad',
        parizcovaFatPercentage: '% de Grasa Parizcova',
        faulknerFatPercentage: '% de Grasa Faulkner',
        training_period: 'Período de Entrenamiento',
      },
    },
    food_category: {
      name: 'Categoría |||| Categorías',
      fields: {
        name: 'Nombre',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    goal: {
      name: 'Objetivo |||| Objetivos',
      fields: {
        name: 'Nombre',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    plan: {
      name: 'Plan |||| Planes',
      summary: 'Resumen del Plan',
      add_to_plan: 'Añadir Alimento',
      fields: {
        comments: 'Comentarios',
        goal_id: 'Meta',
        user_id: 'Usuario',
        created_at: 'Creado',
        updated_at: 'Actualizado',
        prescribed_food: 'Alimentos en Plan',
      },
    },
    food_has_eating_moment: {
      name: 'Alimento por Momento',
      fields: {
        eating_moment_id: 'Momento',
        food_id: 'Alimento',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    food: {
      name: 'Alimento |||| Alimentos',
      fields: {
        calories: 'Calorías',
        chos: 'Carbohidratos',
        description: 'Descripción',
        fat: 'Grasa',
        measure_unit: 'Unidad de Medida',
        protein: 'Proteína',
        quantity: 'Cantidad',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    food_has_food_category: {
      name: 'Categoría de Alimento |||| Categorías de Alimentos',
      fields: {
        food_id: 'Alimento',
        food_category_id: 'Categoría',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    eating_moment: {
      name: 'Momento |||| Momentos',
      fields: {
        name: 'Nombre',
        time: 'Hora',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    nutritionist: {
      name: 'Nutricionista |||| Nutricionistas',
      fields: {
        address: 'Dirección',
        email: 'Correo Electrónico',
        firstname: 'Nombre',
        phone: 'Teléfono',
        lastname: 'Apellido',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    prescribed_food: {
      name: 'Alimentos en Plan |||| Alimentos en Planes',
      fields: {
        eating_moment_name: 'Momento',
        eating_moment_time: 'Hora',
        food_id: 'Alimento',
        plan_id: 'Plan',
        prescribed_quantity: 'Cantidad Prescrita',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    referenced_somatotype: {
      name: 'Somatotipo |||| Somatotipos',
      fields: {
        sport: 'Deporte',
        gender: 'Género',
        endomorph: 'Endomorfo',
        mesomorph: 'Mesomorfo',
        ectomorph: 'Ectomorfo',
        ectomortph: 'Ectomorfo',
        x: 'x',
        y: 'y',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
    },
    result: {
      name: 'Resultado |||| Resultados',
      body_type: 'Tipo de Cuerpo',
      tabbed_data: 'Datos Tabulados',
      fat_percentages: '% de Grasa',
      imc_analysis: 'Análisis de IMC',
      x_y_compairson: 'Comparación X / Y',
      x_y_actual: 'Resultado Actual',
      x_y_referenced: 'Referencia',
      historic: 'Histórico de Resultados',
      fields: {
        endomorph: 'Endomorfo',
        mesomorph: 'Mesomorfo',
        ectomorph: 'Ectomorfo',
        resultX: 'Resultado X',
        resultY: 'Resultado Y',
        imc: 'IMC',
        iaks: 'IAKS',
        complexion: 'Compleción',
        raizPT: 'Raíz PT',
        conicIndex: 'Índice Cónico',
        sumOfPlgs: 'Suma de Pliegues',
        sumaPlieguesEndo: 'Suma de Pliegues Endo',
        endoFactor: 'Factor Endo',
        yhaszFatPercentage: '% de Grasa Yhasz',
        ponderalIndex: 'Índice Ponderal',
        faulknerFatPercentage: '% de Grasa Faulkner',
        parizcovaFatPercentage: '% de Grasa Parizcova',
        fatWeight: 'Peso de Grasa',
        freeFatWeight: 'Peso Libre de Grasa',
        activeMass: 'Masa Activa',
        residualWeight: 'Peso Residual',
        desiredWeight: 'Peso Deseado',
        desiredIMC: 'IMC Deseado',
        desiredFat2MethodPercentage: '% Deseado del Método 2 de Grasa',
      },
    },
    athlete: {
      name: 'Atleta |||| Atletas',
      fields: {
        name: 'Nombre',
        document: 'Documento',
        birth_date: 'Fecha de Nacimiento',
        email: 'Correo Electrónico',
        phone: 'Celular',
        club: 'Club',
        position: 'Posición',
      },
    },
    skill_test: {
      name: 'Prueba de Habilidad |||| Pruebas de Habilidad',
      fields: {
        cod_sin: 'Cod Sin',
        cod_con_el: 'Cod Con El',
        diff_percentage: 'Porcentaje Diferencia',
        d_der: 'D Der',
        d_izq: 'D Izq',
        tl: 'Tl',
        athlete: 'Atleta',
        position: 'Posición',
      },
    },
    physical_test: {
      name: 'Examen Físico |||| Exámenes Físicos',
      fields: {
        position: 'Posición',
        weight: 'Peso',
        height: 'Altura',
        wingspan: 'Envergadura',
        five_mt: 'Cinco Metros',
        ten_mt: 'Diez Metros',
        t_test_left: 'T Test Izquierda',
        t_test_right: 'T Test Derecha',
        athlete: 'Atleta',
      },
    },
  },
  user_list: {
    title: 'Registro Histórico de Sujetos',
    subtitle: 'Catálogo Oficial de Expedientes Biométricos & Atletas',
    total_badge: 'Expedientes Archivados: %{count}',
    specimen_id: 'ID Registro',
    athlete: 'Atleta / Nombre Completo',
    sex: 'Sexo Biológico',
    contact: 'Contacto / Teléfono',
    birth_age: 'Nacimiento & Edad',
    specialist: 'Especialista Asignado',
    registered_on: 'Fecha Alta',
    actions: 'Acciones',
    inspect: 'Examinar Expediente',
    empty_title: 'Sin expedientes registrados',
    empty_desc: 'No se encontraron sujetos en este catálogo archivístico.',
    ledger_folio: 'Registro Oficial del Cuaderno Antropométrico • Folio de Archivo Activo',
    active_entries: 'Total Registrados: %{count}',
  },
  measurement_list: {
    title: 'Índice de Evaluaciones Antropométricas',
    subtitle: 'Registro Oficial de Protocolos ISAK y Somatocartas',
    total_evaluations: 'Evaluaciones Totales: %{count}',
    control_number: 'Nº Control',
    athlete: 'Atleta Evaluado',
    evaluation_date: 'Fecha Evaluación',
    measurements: 'Talla / Peso',
    period: 'Período',
    notes: 'Observaciones Clínicas',
    view_sheet: 'Ver Ficha ISAK',
    view_analytics: 'Somatocarta & Analítica',
    empty_title: 'Sin evaluaciones antropométricas',
    empty_desc: 'No existen registros de protocolos ISAK capturados en el sistema.',
    ledger_folio: 'Protocolo ISAK Oficial • Registro Longitudinal de Evaluaciones',
    active_entries: 'Total Evaluaciones: %{count}',
  },
  nutritionist_list: {
    title: 'Directorio del Cuerpo de Especialistas',
    subtitle: 'Colegio de Antropometristas & Nutricionistas del Laboratorio',
    specialists_count: 'Especialistas Activos: %{count}',
    specialist: 'Especialista',
    credential: 'Nivel ISAK / Certificación',
    contact: 'Contacto Directo',
    address: 'Sede / Consultorio',
    registered_on: 'Fecha de Registro',
    actions: 'Acciones',
    inspect: 'Ficha Profesional',
    empty_title: 'Sin especialistas registrados',
    empty_desc: 'No se encontraron profesionales de nutrición en el directorio.',
    ledger_folio: 'Directorio del Cuerpo Profesional • Cuadro Médico Oficial',
    active_entries: 'Especialistas Activos: %{count}',
  },
  referenced_somatotype_list: {
    title: 'Catálogo de Somatotipos de Referencia',
    subtitle: 'Perfiles Morfométricos Canónicos por Disciplina Deportiva & Género',
    catalog_count: 'Perfiles Catalogados: %{count}',
    sport: 'Disciplina Deportiva',
    category: 'Categoría / Género',
    endomorphy: 'Endomorfia',
    mesomorphy: 'Mesomorfia',
    ectomorphy: 'Ectomorfia',
    coordinates: 'Coordenadas (X, Y)',
    last_update: 'Última Revisión',
    inspect: 'Ver Morfograma',
    empty_title: 'Sin perfiles de referencia',
    empty_desc: 'No se han registrado somatotipos canónicos en el catálogo.',
    ledger_folio: 'Catálogo Canónico Internacional • Somatotipos de Élite',
    active_entries: 'Perfiles Canónicos: %{count}',
  },
  measurement_form: {
    create_title: 'Nuevo Protocolo de Evaluación ISAK',
    edit_title: 'Edición de Evaluación Antropométrica',
    subtitle: 'Cuaderno Oficial de Registro Antropométrico & Biometría',
    section_a: 'Sección A: Datos Administrativos & Generales',
    section_b: 'Sección B: Pliegues Cutáneos Caliper (mm)',
    section_c: 'Sección C: Perímetros Corporales (cm)',
    section_d: 'Sección D: Diámetros Óseos (cm)',
    section_e: 'Sección E: Marcadores Bioquímicos & Coordenadas',
    athlete_select: 'Seleccionar Atleta Registrado',
    somatotype_select: 'Somatotipo de Referencia',
    specialist_select: 'Nutricionista Responsable',
    control: 'Número de Control',
    training_period: 'Período de Entrenamiento',
    evaluation_date: 'Fecha de Evaluación',
    notes: 'Notas y Observaciones Clínicas',
    weight: 'Peso Corporal (kg)',
    height: 'Talla / Estatura (cm)',
    wingspan: 'Envergadura (cm)',
    creatinine: 'Creatinina Sérica (mg/dL)',
    t3_t4: 'T3 / T4 Tiroides',
    x_coord: 'Coordenada Somatocarta X',
    y_coord: 'Coordenada Somatocarta Y',
    save: 'Registrar Protocolo ISAK',
    save_changes: 'Guardar Modificaciones',
  },
  tour: {
    button_title: 'Tutorial',
    restart_tooltip: 'Iniciar Tutorial Guiado del Atelier',
    step_counter: 'Paso %{current} de %{total}',
    skip: 'Saltar Tutorial',
    previous: 'Anterior',
    next: 'Siguiente',
    finish: 'Comenzar a Trabajar',
    dont_show_again: 'No volver a mostrar automáticamente',
    step1_title: 'Bienvenido al Atelier de Antropometría',
    step1_subtitle: 'Sistema Profesional de Somatotipificación & Biometría',
    step1_desc: 'Este laboratorio digital le permite gestionar expedientes confidenciales de atletas, procesar protocolos estandarizados ISAK y generar somatocartas y analíticas de composición corporal en tiempo real.',
    step2_title: 'Expedientes de Pacientes & Atletas',
    step2_subtitle: 'Confidencialidad y Aislamiento Clínico',
    step2_desc: 'Cada especialista cuenta con un catálogo exclusivo de pacientes. Puede buscar, ordenar por columnas y consultar la ficha técnica individual con antecedentes demográficos y de contacto.',
    step3_title: 'Protocolos de Medición ISAK',
    step3_subtitle: 'Registro Riguroso de Medidas Antropométricas',
    step3_desc: 'Ingrese mediciones categorizadas: pliegues cutáneos (tríceps, subescapular, bíceps, etc.), perímetros corporales y diámetros óseos, vinculados automáticamente a su respectivo control clínico.',
    step4_title: 'Analítica, Somatocarta & Radar',
    step4_subtitle: 'Cálculo Heath-Carter & Perfiles de Élite',
    step4_desc: 'El motor biométrico calcula al instante las coordenadas (X, Y) y clasifica el somatotipo (Endomórfico, Mesomórfico, Ectomórfico), comparándolo gráficamente con perfiles canónicos por deporte.',
    step5_title: 'Configuración Dinámica de Módulos',
    step5_subtitle: 'Personalice el Atelier a su Flujo Clínico',
    step5_desc: 'Active o desactive módulos según sus necesidades (solo pacientes, solo analítica, exportación PDF, somatotipos de referencia) directamente desde el botón "Módulos" de la barra superior.',
    step6_title: 'Perfil Profesional & Seguridad',
    step6_subtitle: 'Gestión de Consultorio y Credenciales',
    step6_desc: 'Actualice su teléfono de consulta, dirección de consultorio y cambie su contraseña con cifrado seguro haciendo clic en su identificador profesional o en el menú de usuario.',
  },
  profile: {
    title: 'Mi Perfil Profesional',
    subtitle: 'Gestión de Datos de Contacto y Seguridad de Credenciales',
    specialist_id: 'ID de Especialista',
    role: 'Rol Asignado',
    assigned_patients: 'Expedientes Asignados',
    firstname: 'Nombre',
    lastname: 'Apellido',
    email: 'Correo Electrónico (Institucional)',
    phone: 'Teléfono / WhatsApp de Contacto',
    address: 'Dirección del Consultorio / Sede',
    change_password_title: 'Actualización Segura de Contraseña',
    current_password: 'Contraseña Actual',
    new_password: 'Nueva Contraseña',
    confirm_password: 'Confirmar Nueva Contraseña',
    password_strength: 'Seguridad de la Contraseña',
    password_mismatch: 'Las contraseñas nuevas no coinciden.',
    current_password_required: 'Debe ingresar su contraseña actual para confirmar los cambios.',
    password_weak: 'La nueva contraseña debe tener al menos 8 caracteres y combinar letras y números.',
    save: 'Guardar Cambios',
    saving: 'Guardando...',
    save_success: 'Perfil y credenciales actualizados exitosamente.',
    save_error: 'Error al actualizar el perfil. Verifique su contraseña actual.',
    close: 'Cerrar',
  },
  forgot_password: {
    link: '¿Olvidó su contraseña?',
    title: 'Asistencia para Acceso Profesional',
    subtitle: 'Protocolo de Seguridad y Restablecimiento de Credenciales',
    description: 'Ingrese el correo institucional registrado con su consulta. Se verificará su cuenta y se coordinará el protocolo seguro de restablecimiento.',
    email: 'Correo Electrónico Registrado',
    send: 'Solicitar Asistencia',
    cancel: 'Volver al Inicio de Sesión',
    status_sent: 'Solicitud registrada. Por motivos de confidencialidad médica, se ha enviado una notificación de seguridad para coordinar el restablecimiento seguro de su acceso.',
    contact_admin: 'Si requiere acceso urgente, comuníquese directamente con la Dirección Técnica del Atelier.',
  },
  import_csv: {
    button: 'Importar Pacientes (CSV)',
    title: 'Carga Masiva de Pacientes y Atletas',
    subtitle: 'Asignación Automática a su Consulta Profesional',
    instructions: 'Descargue la plantilla oficial CSV, complete los datos de sus atletas y cargue el archivo. Todos los pacientes importados quedarán vinculados a su expediente.',
    download_template: 'Descargar Plantilla CSV',
    select_file: 'Seleccionar Archivo (.csv)',
    drop_file: 'Haga clic para seleccionar o arrastre el archivo CSV aquí',
    preview_title: 'Expedientes a Importar (%{count} registros válidos)',
    import_now: 'Confirmar e Importar al Atelier',
    importing: 'Importando registros a la base de datos...',
    success: '¡Importación completada! Se registraron exitosamente %{count} pacientes.',
    error: 'Error en la importación: %{message}',
    no_file: 'Por favor seleccione un archivo CSV válido antes de continuar.',
    col_firstname: 'Nombre',
    col_lastname: 'Apellido',
    col_email: 'Correo',
    col_phone: 'Teléfono',
    col_gender: 'Género',
    col_birthday: 'Nacimiento',
    col_address: 'Dirección',
    cancel: 'Cancelar',
  },
};

